import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'xcdrs-country-not-available-dialog',
  templateUrl: './country-not-available-dialog.component.html',
  styleUrls: ['./country-not-available-dialog.component.scss']
})
export class CountryNotAvailableDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
